import React, { useState, useEffect } from 'react'
import "../css/giglist.css"
import { motion, useAnimation } from "framer-motion"
import { useInView } from "react-intersection-observer"
import '../css/tour2.css'



const Giglist = (props) => {

const [ tickets, setTickets ] = useState(false)

const getTickets = {
    open: { opacity: 1 },
    closed: { opacity: 0 },
}

const { ref, inView } = useInView()
const animation = useAnimation()
const animation2 = useAnimation()
const animation3 = useAnimation()

useEffect(() => {
    if(inView){
        animation.start({ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 0.2} })
        animation2.start({ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 0.35} })
        animation3.start({ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 0.5} })
    }
    if(!inView){
        animation.start({ y: '100%', transition: { ease: 'linear', duration: 0.3 } })
        animation2.start({ y: '100%', transition: { ease: 'linear', duration: 0.3 } })
        animation3.start({ y: '100%', transition: { ease: 'linear', duration: 0.3 } })
    }
}, [inView])

const months = [ "JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC" ]
const getMonth = parseInt(props.date2 - 1)
const abbMonth = months[getMonth]


  return (
        // <motion.a style={{ textDecoration: "none" }} onMouseEnter={() => setTickets(true)} onMouseLeave={() => setTickets(false)} href={props.tickets} target="_blank">
            <a ref={ref} onMouseEnter={() => setTickets(true)} onMouseLeave={() => setTickets(false)} href={props.tickets} target="_blank" className='tour-cell' style={{ textTransform: 'uppercase', textDecoration: "none" }}>
                <motion.div whileHover={{ opacity: 0.5 }}>
                    {/* <div style={{ position: 'absolute', width: '70%', height: '100%', backgroundColor: 'red', marginTop: '-5rem'  }}></div> */}
                                <div className='date-wrapper'>
                                    <div style={{ overflow: 'hidden' }}><motion.div animate={ animation }>
                        {/* { `${abbMonth} ${props.date1}` } */}
                         {props.date1 === props.date3 ? `${abbMonth} ${props.date1}` 
                    : props.date1 ? `${abbMonth} ${props.date1}-${props.date3}` 
                    : "TBA"}
                    {/* { `${abbMonth} ${props.date1}` }{ props.date3 && ` - ${props.date3}` } */}
                        </motion.div></div>
                                    <h5 className='smalldate'>DATE</h5>
                                    <h5 className='smallwhen'>WHEN</h5>
                                </div>
                                <div className='bigevent'><motion.div animate={ animation2 }>{props.event}</motion.div>
                                    <h5 className='smallevent'>EVENT</h5>
                                </div>
                                <div className='biglocation'>
                                    <div style={{ overflow: 'hidden' }}>
                                    <motion.div animate={ animation3 }>{props.city}<br />{props.country} </motion.div>
                                    </div>
                                    <h5 className='smalllocation'>LOCATION</h5>
                                    <h5 className='smallwhere'>WHERE</h5>
                                </div>
                </motion.div>
            </a>
                          

            
  )
}

export default Giglist

{/* <motion.div className='gig-entry'>
                <div className="event-date">
                    <motion.div animate={ animation } className="date" style={{ minWidth: '250px' }}>
                    {props.date1 === props.date3 ? `${abbMonth} ${props.date1}` 
                    : props.date1 ? `${abbMonth} ${props.date1}-${props.date3}` 
                    : "TBA"}
                    </motion.div>
                </div>
                <div ref={ref} className="event">
                    <motion.div animate={ animation }  className="event-location">
                    {props.event}<br />
                    {props.city}, {props.country} 
                    </motion.div>
                </div>
                <div className="tickets"><motion.div animate={ animation } className="buy">TICKETS</motion.div></div>
            </motion.div>         */
        /* </motion.a> */}